let faTable = null;
let faModule = null;

function userNotPremium(anonymous)
{
    const notPremium = '<a href="/suscripcion" class=\"lnk\" title=\"Para ver este contenido debes suscribirte\">Suscríbete</a> ';
    const notRegister = notPremium + '&nbsp; o &nbsp; <a href="#suscriptionModal" class="lnk" title="Para ver este contenido debes ser suscriptor" data-lightbox="">accede</a>';
    const message = anonymous ? notRegister : notPremium;
    faTable.children[1].innerHTML = message
    // if (faModule) faModule.innerHTML = message Este siempre es público
}

const getTextResult = (score) => {
    if (score>4) return "Muy Infravalorada";
    if (score>2) return "Infravalorada";
    if (score>-1) return "Neutral";
    if (score>-3) return "Sobrevalorada";
    else return "Muy Sobrevalorada";
}

//Método Alberto.
function generateScore(score) {
    if (isNaN(score)) {
        return '-';
    }
    const div = document.createElement('div');
    div.title = getTextResult(score);
    div.classList.add('ei-fundamental-synthesis-value')


    let count = score;
    for (let i = 0; i < 6; i++) {
        if (score < 0 && count < 0) {
            div.insertAdjacentHTML("beforeend",'<div class="square updateDown"></div>');
            count++;
        } else if (score > 0 && count > 0) {
            div.insertAdjacentHTML("beforeend",'<div class="square updateUp"></div>');
            count--;
        } else {
            div.insertAdjacentHTML("beforeend",'<div class="square"></div>');
        }
    }

    return div;
}

//Otro.
const getPremiumModuleSquares = (score) => {
    if (isNaN(score)) {
        return '-';
    }
    const div = document.createElement('div');
    div.title = getTextResult(score);
    div.classList.add('tradingSquare__holder')

    const color = score < 0 ? 'faDown' : 'faUp';
    const absoluteScore = Math.abs(score);

    for(let i = 1; i <= 6; i++) {
        const style = `${color} ${(i <= absoluteScore ? `faActive` : ``)}`
        div.insertAdjacentHTML("beforeend",`<div class="tradingSquare ${style}"></div>`);
    }

    return div;
}



const loadFAData = async (idTicker) => {
    const url = `${unmaskpath(JSVAR.base_url)}/cotizaciones-fa/${idTicker}`
    const result = await fetch(url);
    if (!result.ok) {
        throw new Error('User menu request has returned non 200 code');
    }
    return result.json();
}

const drawFa = async (idTicker ) => {
    try {
        const response = await loadFAData(idTicker);
        if (!response || response.error) {
            console.warn('No FA data available');
            return;
        }

        //El servicio ha devuelto el campo data (premium): creamos la tabla inferior.
        if (response.data && response.data.length) {
            //Crear el holder para la tabla general
            const holder = document.createElement('tr');
            holder.insertAdjacentHTML("beforeend", '<td class="sk-1">Puntuación</td>')
            response.data.forEach(item => {
                const td = document.createElement('td')
                td.classList.add('sk-1')
                td.appendChild(generateScore(item.score))
                holder.appendChild(td)
            })
            faTable.replaceWith(holder)
        } else {
            userNotPremium(true);
        }

        //Crear el módulo para el módulo superior. Campo "current" (disponible en abierto)
        if (response.current && faModule) {
            const currentData = response.current;
            const text = getTextResult(currentData.score);
            faModule.innerHTML = '';
            faModule.appendChild(getPremiumModuleSquares(currentData.score));
            faModule.insertAdjacentHTML('beforeend', '<div class="premiumData__text">'+text+'</div>')
        }

    } catch (err) {
        console.error(err)
        faTable.innerHTML = `<tr><td class="sk-1">Puntuación</td><td colspan="4">No disponible</td></tr>`
        if(faModule) faModule.innerHTML = "No disponible"
    }
}


/**
 * Carga los datos de Análisis fundamental en la ficha de cotización
 */
export const premiumFaStock = async () => {
    //Módulo superior para usuarios suscritos
    faModule = document.querySelector('.premiumData__container.premiumData__faContainer');
    //Tabla de la ficha donde se muestran los últimos 4 años.
    faTable = document.querySelector('.stock-fa-scores');

    if (!faTable && !faModule) {
        return;
    }

    const idTicker = faTable.dataset.instrument;
    await drawFa(idTicker)
}
